import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const CenterVisitAverageRedux = createActions({},
  {
    prefix: 'CENTER_VISIT_AVERAGE_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = CenterVisitAverageRedux
export const CenterVisitAverageTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CenterVisitAverageRedux.js